export const getLastImagePart = (url: string) => {
  return url.split("/").pop();
};
